import {gql} from "@apollo/client";
import {USER_FRAGMENT, SURVEY_FRAGMENT} from "graphql/fragments/fragments";

export const CHECK_LOGIN = gql`
	{
		me {
			id
			email
		}
		csrfToken
	}
`;

export const GET_ALL_BRANDS = gql`
	query GetBrands {
		brands {
			items {
				id
				name
				description
				logoUrl
				logoPicture {
					url(version:MEDIUM)
				}
				category {
					id
					name
				}
			}
		}
	}
`;

export const GET_USER = gql`
	query GetUser {
		me {
			...UserFields
		}
	}
	${USER_FRAGMENT}
`;

export const GET_COUNTRIES = gql`
	query GetCountries {
		countries {
			id
			name
		}
	}
`;

export const GET_ETHINICITIES = gql`
	query GetEthnicities {
		ethnicities {
			id
			name
		}
	}
`;

export const GET_OPPORTUNITIES = gql`
	query GetOpportunities {
		opportunities {
			items {
				...SurveyFields
			}
		}
	}
	${SURVEY_FRAGMENT}
`;

export const GET_COMPLETES = gql`
	query GetCompletes {
		completes {
			items {
				...SurveyFields
				completedResponses {
					completedAt
				}
			}
		}
	}
	${SURVEY_FRAGMENT}
`;

export const GET_USER_PICTURE = gql`
	query GetUserPicture($id: GUID!) {
		userPicture(id: $id) {
			id
			transcodingStatus
		}
	}
`;
